module.exports = __webpack_public_path__ + "img/empty_blocked.89c73dc2.svg";